// Module
var code = " <md-input-container class=\"dv-input-container\"> <ng-transclude></ng-transclude> </md-input-container> ";
// Exports
module.exports = code;